import { useSuspenseQuery } from '@apollo/client/react';
import { useNavigate } from 'react-router';
import { ArrowRightIcon } from 'lucide-react';

import { AwaitingLegacyReposCountDocument } from 'src/graphql/actions/legacyRepos/awaitingLegacyReposCount.query';
import { MigrationAlert } from 'src/components/Migration';
import { withSuspense } from 'src/hoc';
import { Button } from 'src/components/ui/button';

const MigrationAlertContainer = () => {
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(AwaitingLegacyReposCountDocument);

  const nodesCount = data?.legacyRepos.count ?? 0;

  if (!nodesCount) return null;

  const text = `A more reliable integration method is available. Migrate your 
        ${nodesCount === 1 ? '1 asset' : `${nodesCount} assets`} to OAuth today.`;

  const goToMigrations = () => navigate('/migrations');

  return (
    <MigrationAlert
      text={text}
      action={
        <Button onClick={goToMigrations} size="sm" className="w-full" variant="outline">
          Go to Migrations <ArrowRightIcon />
        </Button>
      }
      className="mb-6"
    />
  );
};

export default withSuspense(MigrationAlertContainer, () => <div />);
